import { useSessionStorage } from "usehooks-ts";

const STORAGE_KEY = "FriendStatusUpdateTime";

export const useFriendStatusUpdateTime = () => {
	return useSessionStorage<string>(STORAGE_KEY, new Date(0).toISOString());
};
